import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const settingsServiceName = "Setting-Service: ";
const SETTING_API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/settings';

export default class SettingService {

  static async readAllSettingsPaginated(page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, successF, errorF, ['key'], ['key']);
    await WrapperService.get(SETTING_API_URL + '/page?' + params, null, settingsServiceName, successF, errorF);
  }

  static async saveSetting(setting, isEdit, successF, errorF) {
    if (isEdit) {
      await WrapperService.put(SETTING_API_URL + '/' + setting.key, setting, settingsServiceName, successF, errorF);
    } else {
      await WrapperService.post(SETTING_API_URL, setting, settingsServiceName, successF, errorF);
    }
  }
}



